import { EventEmitter, Injectable } from '@angular/core';
import { RegistrationService } from '../../registration.service';
import { ApplicationStateService } from '../../../../../shared/services/application-state.service';
import { CessionSectionComponent } from '../../../../../shared/sections/web/cession-section/cession-section.component';
import { CessionDataInterface } from '../../../api/sections-api/cession-data.interface';
import { RegistrationStorageService } from '../../../../../shared/services/registration-storage.service';
import { CalculationService } from '../../calculation.service';
import { InsuranceCompanyCode } from '../../../../../shared/models/insurance-company-code.enum';
import {InsuranceCompanyApiService} from '../../../insurance-company-api.service';

@Injectable({
  providedIn: 'root'
})
export class CessionStateService implements CessionDataInterface {

  public cessionSection: CessionSectionComponent;
  public banksDictionaryEvent: EventEmitter<any> = new EventEmitter();
  private _bankItems = [];

  constructor(private registration: RegistrationService,
              private appState: ApplicationStateService,
              private storage: RegistrationStorageService,
              private insuranceCompanyApiService: InsuranceCompanyApiService,
              private calculation: CalculationService) {

    if (this.postalCodeFromState) {
      this.banksDictionary(this.postalCodeFromState);
    }
  }

  get postalCodeFromState(): string {
    return this.appState.cessionPostalCode;
  }

  get cessionData() {
    return this.registration.cessionData;
  }

  get postalCode(): string {
    return this.calculation.insurerData.address.postalCode;
  }

  get insuranceCompanyCode(): InsuranceCompanyCode {
    return this.appState.insuranceCompanyCode;
  }

  get bankItems() {
    return this._bankItems;
  }

  public banksDictionary(postalCode: string) {
    this.insuranceCompanyApiService.findBanks(postalCode).then(resp => {
      this._bankItems = resp['getBankBranchesResponse']['bankBranch'];
    }).catch(e => {
      this._bankItems = [];
    }).finally(() => {
      this.banksDictionaryEvent.emit();
    });
  }

  public changeIsCession(isCession: boolean) {
    this.cessionData.isCession = isCession;
    if (!isCession) {
      this._bankItems = [];
    }
    this.storage.updateRegistration();
  }

  public changeAmount(amount: number): void {
    this.cessionData.amount = amount;
    this.storage.updateRegistration();
  }

  public changeBankId(bankId: string): void {
    this.cessionData.bankId = bankId;
    this.storage.updateRegistration();
  }

  public changePostalCode(postalCode: string): void {
    if (this.cessionData.isCession) {
      this.appState.cessionPostalCode = postalCode;
      this.banksDictionary(postalCode);
    }
  }

  public resetCessionPostalCode(): void {
    this.appState.cessionPostalCode = null;
  }

}
